import { mapGetters, mapMutations, mapActions } from 'vuex'

export default {
  props: {
    value: {
      required: true,
      type: Boolean
    }
  },
  data () {
    return {
      dialog: false,
      isLoading: false,
      periodList: [
        { name: 'Todo o período', value: 0 },
        { name: 'Últimos 90 dias', value: 90 },
        { name: 'Últimos 60 dias', value: 60 },
        { name: 'Últimos 30 dias', value: 30 }
      ],
      selectedPeriod: { name: 'Últimos 30 dias', value: 30 },
      headers: [
        { text: 'Data', value: 'createdAt', align: 'left' },
        { text: 'Usuário', value: 'userName', align: 'left' },
        { text: 'Descrição', value: 'observation', align: 'left' },
        { text: 'Valor', value: 'value', align: 'right' }
      ],
      selectedFilter: 'userName',
      search: '',
      pagination: {},
      rowsPerPage: [10, 20, 30, 45, 65],
      closedExtract: 'INFORMATION'
    }
  },
  computed: {
    ...mapGetters([
      'getterSelectedClient',
      'getterAllExtracts'
    ]),
    filteredHeader () {
      return this.headers.filter((item) => item.value === 'userName' || item.value === 'value' || item.value === 'observation')
    },
    filteredAllExtracts () {
      let filteredList = []

      if (this.getterAllExtracts && Object.keys(this.getterAllExtracts).length > 0 && this.getterAllExtracts.results) {
        filteredList = this.getterAllExtracts.results.map((item) => {
          const { data } = item

          delete item.data

          if (item.reference === 'CREDIT') {
            if (typeof item.value === 'string') {
              item.value = parseFloat(item.value.replace(/ |-|\+/gi, '').replace(/,/g, '.'))
            }

            item.value = `+ ${this.formatMoneyToReal(item.value)}`
          } else if (item.reference === 'DEBIT') {
            if (typeof item.value === 'string') {
              item.value = parseFloat(item.value.replace(/ |-|\+/gi, '').replace(/,/g, '.'))
            }

            item.value = `- ${this.formatMoneyToReal(item.value)}`
          }

          return {
            ...item,
            ...data
          }
        })

        if (this.search !== '') {
          filteredList = filteredList.filter((item) => {
            if (item[this.selectedFilter] !== null) {
              return item[this.selectedFilter].toLowerCase().includes(this.search.toLowerCase())
            }

            return item[this.selectedFilter]
          })
        }

        this.pagination.totalItems = this.getterAllExtracts.totalResults
      }

      return filteredList
    }
  },
  watch: {
    pagination: {
      handler (oldValue, newValue) {
        if ((oldValue.page !== newValue.page) || (newValue.totalItems !== this.getterAllExtracts.totalResults)) {
          this.getAllExtract()
        }
      },
      deep: true
    }
  },
  mounted () {
    this.dialog = true
  },
  beforeDestroy () {
    this.SET_SELECTED_CLIENT()
    this.CLEAR_EXTRACTS_STORE()
  },
  methods: {
    ...mapActions([
      'actionGetAllExtracts'
    ]),
    ...mapMutations([
      'SET_SELECTED_CLIENT',
      'CLEAR_EXTRACTS_STORE'
    ]),
    getAllExtract () {
      const params = {
        idClient: this.getterSelectedClient.idClient,
        days: this.selectedPeriod.value,
        page: (this.pagination && this.pagination.page) ? this.pagination.page : 1,
        limit: this.pagination.rowsPerPage || this.rowsPerPage[0]
      }

      this.isLoading = true

      this.actionGetAllExtracts(params)
        .then(() => {
          this.isLoading = false
        })
        .catch(() => {
          this.isLoading = false

          this.sendToast({
            text: 'Ocorreu um erro ao buscar os extratos, tente novamente mais tarde!',
            type: 'danger'
          })
        })
    },
    closeModal () {
      this.isLoading = this.dialog = false

      setTimeout(() => {
        this.$emit('input', false)
      }, 300)
    }
  }
}
